export default __webpack_public_path__ + "locales/es/MainBar.json?hash=d64b9eb7d61fc057f69c0e3fbba24b14";